<div v-if="catItem" class="tt-c-review-flow-product" :class="{'tt-c-review-flow-product--review-form': forReviewForm}">
  <tt-product-image v-if="catItem"
                    class="tt-c-review-flow-product__item-image" 
                    :catItem="catItem"
                    :includeAlt="false"
                    :siblingSiteKey="siblingSiteKey"></tt-product-image>
  <div class="tt-c-review-flow-product__item-heading">
    <div class="tt-c-review-flow-product__item-title" v-html="catItem.title"></div>
  </div>
</div>